<template>
  <div class="sidearm-mm-animated-text flex-column">
    <div class="sidearm-mm-animated-text__item" :style="animation">
      {{ text }}
    </div>
    <div class="sidearm-mm-animated-text__item" :style="animation">
      {{ text }}
    </div>
    <div class="sidearm-mm-animated-text__item" :style="animation">
      {{ text }}
    </div>
    <div class="sidearm-mm-animated-text__item" :style="animation">
      {{ text }}
    </div>
    <div class="sidearm-mm-animated-text__item" :style="animation">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: "AnimatedText",

  props: ["speed", "text"],

  computed: {
    animation() {
      return `animation-duration: ${this.speed};`;
    }
  }
};
</script>

<style lang="scss" scoped>
@keyframes scroll_vertical_text {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-100%);
  }
}

.sidearm-mm-animated-text {
  opacity: 0.2;
  pointer-events: none;
  position: absolute;
  right: #{grid_percent(120)};
  top: 0;
  z-index: 1;

  &__item {
    -webkit-text-stroke: 1px $color-white;
    animation: scroll_vertical_text 10s infinite linear forwards;
    color: transparent;
    font-family: $font-abolition;
    font-size: 22.5rem;
    line-height: 1;
    padding: $spacer * 8 0;
    text-transform: uppercase;
    transform: rotate(180deg);
    white-space: nowrap;
    writing-mode: vertical-rl;

    &::after {
      border-radius: 50%;
      border: 1px solid $color-white;
      bottom: #{$spacer * -2};
      content: "";
      height: 12px;
      left: 50%;
      position: absolute;
      transform: translateX(calc(-50% - #{$spacer * 2}));
      width: 12px;
    }
  }
}

@media (prefers-reduced-motion: reduce) {
  .sidearm-mm-animated-text__item {
    animation: none;
  }
}
</style>
